export function NineBoxCode(perf, potential) {
  return "NineBox" + potential + perf;
}
